var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('close-open-operation-container',{attrs:{"batch-operation":_vm.batchOperation}}),_c('operation-information',{attrs:{"information-to-display":_vm.batchOperation.informationToDisplay,"instructions":_vm.batchOperation.operation.instructions,"document":_vm.batchOperation.operation.document}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }